import getTypeByTrigger from './utils/getTypeByTrigger';

const findMentionEntities = (trigger) => (contentBlock, callback, contentState) => {
  // TODO: detect mention entities by regex when editing
  // Detect all mentions with format: { field name }
  const text = contentBlock.get('text');
  const mentionRegex = /{[a-zA-Z._|\s]+}/gi;
  const mentions = text.match(mentionRegex);
  if (typeof mentions !== 'undefined' && mentions !== null) {
    let matchArr, start;
    while ((matchArr = mentionRegex.exec(text)) !== null) {
      start = matchArr.index;
      callback(start, start + matchArr[0].length);
    }
  } else {
    contentBlock.findEntityRanges((character) => {
      const entityKey = character.getEntity();
      return (
        entityKey !== null &&
        contentState.getEntity(entityKey).getType() === getTypeByTrigger(trigger)
      );
    }, callback);
  }
};

export default findMentionEntities;
